export const getDirectionFormSuffix = (directionId?: string | null) =>
  directionId ? String(directionId) : 'new';

export const createDirectionFormIds = (directionId?: string | null) => {
  const suffix = getDirectionFormSuffix(directionId);
  const id = (prefix: string) => `${prefix}-${suffix}`;
  const option = (list: string) => (optionId: number, index: number) =>
    `${id(list)}-${optionId}-${index}`;
  return {
    postalCode: id('cod-entrega'),
    locality: id('localidad-entrega'),
    road: id('via-entrega'),
    number: id('num-entrega'),
    portal: id('portal-entrega'),
    stairs: id('escalera-entrega'),
    floor: id('piso-entrega'),
    door: id('puerta-entrega'),
    prefix: id('pais-contacto-online'),
    phone: id('tf-online'),
    postalCodeError: id('codPostal-error'),
    postalCodeNotSelectedError: id('codPostal-error-not-selected'),
    localityError: id('localidadEntrega-error'),
    roadError: id('viaEntrega-error'),
    numberError: id('numEntrega-error'),
    prefixError: id('prefijoTelefonoMovil-error'),
    phoneError: id('tfOnline-error'),
    postalCodeAutocomplete: id('ui-id-30'),
    roadAutocomplete: id('ui-id-29'),
    postalCodeOption: option('ui-id-30-option'),
    roadOption: option('ui-id-29-option'),
  };
};

export type DirectionFormIds = ReturnType<typeof createDirectionFormIds>;
export type DirectionAutocompleteDomIds = Pick<
  DirectionFormIds,
  'postalCode' | 'locality' | 'road'
>;

export const updatePostalCodeSelectionErrors = (ids: DirectionFormIds) => {
  const generalError = document.getElementById(ids.postalCodeError);
  const selectionError = document.getElementById(
    ids.postalCodeNotSelectedError,
  );
  const postalCodeInput = document.getElementById(
    ids.postalCode,
  ) as HTMLInputElement;
  if (selectionError) selectionError.classList.add('hide');
  if (generalError) generalError.classList.add('hide');
  if (/(^[0-9]{5}$)|^(GX11 1AA)$/i.test(postalCodeInput.value)) {
    if (selectionError) selectionError.classList.remove('hide');
    postalCodeInput.classList.add('error');
  } else if (generalError) generalError.classList.remove('hide');
};
